<template>
    <div class="hot-point-wrapper">
        <div class="hot-select">
            <div>
                <span class="hot-label">{{ redPointLabel }}</span>
                <OnOffSwitch class="hot-switch" :state="redPoint" @switch="redSwitch" />
            </div>
            <RadioGroup class="hot-radio" v-show="isRedOn" :radios="radios" :space="8" :beteewn="0" :disabled="!isRedOn" @change="radioChange" />
        </div>
        <div class="hot-date" v-show="isRedOn">
            <SingleCalendar
                @dateSelect="setEndDate"
                class="hot-time-select"
                :disableRanges="disableRanges"
                :value="endDate"
                :config="calendarConfig"
                :disabled="!isRedOn"
            ></SingleCalendar>
        </div>
    </div>
</template>

<script>
import OnOffSwitch from "@/views/zhiji/bComponents/switchs/OnOffSwitch";
import RadioGroup from "@/views/zhiji/bComponents/checks/RadioGroup";
import SingleCalendar from "@/views/zhiji/bComponents/calendar/SingleCalendar";

export default {
    name: "HotPointPanel",
    props: ["data"], // data={redState, hotItem, endTime}
    components: {
        OnOffSwitch,
        RadioGroup,
        SingleCalendar
    },
    data() {
        return {
            redPoint: this.data.redState || "off",
            hotItem: this.data.hotItem || "NEW", // "NEW" "HOT"
            disableRanges: [
                {
                    end: new Date(Date.now() - 24 * 60 * 60 * 1000) // 只可选择今天以后的日期
                }
            ],
            endDate: this.data.endTime ? new Date(this.data.endTime) : "",
            radios: [
                {
                    label: "HOT",
                    value: "HOT",
                    checked: this.data.hotItem == "HOT"
                },
                {
                    label: "NEW",
                    value: "NEW",
                    checked: this.data.hotItem != "HOT"
                }
            ]
        };
    },
    watch: {
        data() {
            this.redPoint = this.data.redState || "off";
            this.hotItem = this.data.hotItem || "NEW";
            this.endDate = this.data.endTime ? new Date(this.data.endTime) : "";
        }
    },
    computed: {
        isRedOn() {
            return this.redPoint == "on" ? true : false;
        },
        redPointLabel() {
            return this.$t("zhiji.common.redPoint");
        },
        calendarConfig() {
            return {
                position: "left",
                placeHolder: this.$t("zhiji.answer.endTime"),
                noInitBorder: true
            };
        }
    },
    methods: {
        redSwitch(state) {
            this.redPoint = state == "on" ? "on" : "off";
            this.$emit("redSwitch", this.redPoint);
        },
        radioChange(hotVal) {
            this.hotItem = hotVal;
            this.radios.forEach(radio => {
                radio.checked = radio.value === hotVal;
            });
            this.$emit("hotSwitch", this.hotItem);
        },
        setEndDate(date) {
            if (date) {
                this.endDate = date;
            }
            this.$emit("endDateChange", date ? this.zhiji.dateFormat(date, "YYYY-MM-DD hh:mm") : "");
        }
    }
};
</script>

<style lang="scss" scoped>
.hot-point-wrapper {
    .hot-select {
        width: 100%;
        display: flex;
        height: 40px;
        padding: 0 8px;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid #d8e4f0;
        box-sizing: border-box;

        .hot-label {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }

    .hot-switch {
        vertical-align: middle;
        margin-left: 5px;
    }

    .hot-radio {
        font-size: 12px;
    }

    .hot-date {
        height: 32px;
        border-top: 1px solid #d8e4f0;
        position: relative;
    }

    .hot-time-select {
        width: 100%;
        position: static;
    }
}
</style>
